
export const identifyUser = (nerveId, userData) => {
    // Identify User using nerve ID
    if (window.analytics) {
        if (nerveId) {
            window.analytics.identify(nerveId, {
                ...userData
            });
        } else {
            window.analytics.identify({
                ...userData
            });
        }
    }
}

export const trackEvent = (event_name, event_property) => {
    // Global logger function to track events
    // Function receives an event name and a property
    if (window.analytics) {
        if (event_property) {
            window.analytics.track(event_name, {
                ...event_property,
            });
        } else {
            window.analytics.track(event_name);
        }
    }
}

export const identifyGroup = (nerveId, userData) => {
    // Identify Group using Business
    if (window.analytics) {
        if (nerveId) {
            window.analytics.group(nerveId, {
                ...userData
            });
        } else {
            window.analytics.group({
                ...userData
            });
        }
    }
}

export const trackPage = (event_name, event_property) => {
    // Global logger function to track events
    // Function receives an event name and a property
    if (window.analytics) {
        if (event_property) {
            window.analytics.page(event_name, {
                ...event_property,
            });
        } else {
            window.analytics.page(event_name);
        }
    }
}

export const resetSegment = () => {
    //segment.reset()
}

export const reset = () => {
    if (window.analytics) {
        window.analytics.reset()
    }
}
